import React from 'react';

/**
 * Toast-Stack — fixed unten rechts.
 * Erwartet `messages` Array mit {id, text, type}.
 */
export default function Toast({ messages }) {
  return (
    <div className="toast-stack">
      {messages.map(t => (
        <div key={t.id} className={`toast toast-${t.type || 'info'}`}>{t.text}</div>
      ))}
    </div>
  );
}
